import {
  CREATE_USER_EVENT,
  CREATE_FOOTPRINT,
  CLEAR_FOOTPRINT
} from './constants'

export const createEvent = event => ({ type: CREATE_USER_EVENT, event })
export const createFootprint = {
  request: contact => ({ type: CREATE_FOOTPRINT['REQUEST'], contact }),
  success: footprint => ({ type: CREATE_FOOTPRINT['SUCCESS'], footprint })
}
export const clearFootprint = () => ({ type: CLEAR_FOOTPRINT })



// WEBPACK FOOTER //
// ./src/containers/UserEvents/actions.js